import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrderSummaryContainerComponent } from '@app/ui/order/order-summary-container/order-summary-container.component';

const routes: Routes = [
  {
    path: '',
    component: OrderSummaryContainerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class OrderRoutingModule {}
